import cameraSVG from "../../../assets/camera.svg";
import styles from "./Buttons.module.css";

const CameraInput = ({ id, imageHandler, disabled }) => {
  let className = disabled ? styles.actionButtonDisabled : styles.actionButton;
  return (
    <div className={styles.imageInputDiv}>
      <label htmlFor={id} className={className}>
        <img alt={id} src={cameraSVG} style={{ padding: "5px" }} />
        <input
          style={{ display: "hidden", width: "0" }}
          type="file"
          id={id}
          name="imageLoader"
          accept="image/*"
          onChange={imageHandler}
          capture="environment"
        />
      </label>
    </div>
  );
};

export default CameraInput;
